<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px">
                <el-row>
                    <el-form-item label="会员地址">
                        <el-input v-model="params.address" clearable class="param-address"></el-input>
                    </el-form-item>
                    <el-form-item label="直推地址">
                        <el-input v-model="params.parentAddress" clearable class="param-address"></el-input>
                    </el-form-item>
                    <el-form-item label="白名单">
                        <el-select v-model="params.whiteFlag" clearable>
                            <el-option label="是" value="Y"></el-option>
                            <el-option label="否" value="N"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
            </div>
        </div>
        <div class="tableTool2">
            <div class="toolLeft">
                <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
                <span class="ps">PS：手动设置社区等级后，会以设置的等级进行结算。</span>
            </div>
            <div class="toolRight">
                <el-button type="primary" @click="syncLeaderData" >同步白名单数据</el-button>
            </div>
        </div>
        <el-table border ref="tableRef" id="out-table" :data="tableData" class="table-show-current" highlight-current-row @row-dblclick="openEdit">
            <el-table-column prop="id" align="center" label="UID" width="60"></el-table-column>
            <el-table-column align="center" label="会员地址" width="120" class-name="address">
                <template slot-scope="scope" v-if="scope.row.address">
                    <span  v-clipboard:copy="scope.row.address" v-clipboard:success="onCopy">
                        {{scope.row.address.slice(0,5) + "..." + scope.row.address.slice(-5)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="nickName" align="center" label="备注" width="100"></el-table-column>
            <el-table-column prop="whiteFlag" align="center" label="白名单" width="60">
                <template slot-scope="scope">{{ scope.row.whiteFlag == "Y"?"是":"否" }}</template>
            </el-table-column>
            <el-table-column prop="whiteWeight" align="center" label="权重" width="60"></el-table-column>
            <!-- <el-table-column prop="registerAt" label="注册时间" align="center" width="140"></el-table-column> -->
            <el-table-column align="center" label="直推地址" width="120" class-name="address">
                <template slot-scope="scope" v-if="scope.row.parentAddress">
                    <span  v-clipboard:copy="scope.row.parentAddress" v-clipboard:success="onCopy">
                        {{scope.row.parentAddress.slice(0,5) + "..." + scope.row.parentAddress.slice(-5)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="parentAt" label="绑定上级时间" align="center" width="140"></el-table-column> -->
            <el-table-column prop="selfAmount" align="center">
                <template slot="header" slot-scope="scope">总投资</template>
            </el-table-column>
            <!-- <el-table-column align="center">
                <template slot="header" slot-scope="scope" width="80">自己等级</br>真实/设置</template>
                <template slot-scope="scope">{{ scope.row.selfLevelAuto }} / {{ scope.row.selfLevelSet }}</template>
            </el-table-column> -->
            <el-table-column prop="inviteNum" align="center">
                <template slot="header" slot-scope="scope">直推数</template>
            </el-table-column>
            <!-- <el-table-column prop="inviteAmount" align="center">
                <template slot="header" slot-scope="scope">直推</br>总金额</template>
            </el-table-column>
            <el-table-column prop="inviteLevelAuto"  align="center">
                <template slot="header" slot-scope="scope"  width="80">直推等级</br>真实/设置</template>
                <template slot-scope="scope">{{ scope.row.inviteLevelAuto }} / {{ scope.row.inviteLevelSet }}</template>
            </el-table-column>
            <el-table-column prop="profitParent" align="center">
                <template slot="header" slot-scope="scope">直推</br>总收益</template>
            </el-table-column> -->
            <!-- <el-table-column prop="teamNum"  align="center">
                <template slot="header" slot-scope="scope">社区</br>总人数</template>
            </el-table-column> -->
            <el-table-column prop="teamAmount" align="center">
                <template slot="header" slot-scope="scope">社区总业绩</template>
            </el-table-column>
            <el-table-column prop="smallAmount" align="center">
                <template slot="header" slot-scope="scope">小区业绩</template>
            </el-table-column>
            <el-table-column align="center">
                <template slot="header" slot-scope="scope"  width="80">社区真实等级</template>
                <template slot-scope="scope">V{{ scope.row.teamLevelAuto }}</template>
            </el-table-column>
            <el-table-column align="center">
                <template slot="header" slot-scope="scope"  width="80">社区设置等级</template>
                <template slot-scope="scope">{{ scope.row.teamLevelSet == 0?"不设置":("V"+scope.row.teamLevelSet) }}</template>
            </el-table-column>
            <!-- <el-table-column prop="profitLeader" align="center">
                <template slot="header" slot-scope="scope">社区</br>总收益</template>
            </el-table-column> -->
            <!-- <el-table-column prop="ctcBalance" align="center" label="可提余额"></el-table-column> -->
            <!-- <el-table-column prop="withdrawTotal" align="center" label="已提总额"></el-table-column> -->
            <el-table-column align="center" label="提现状态" width="80">
                <template slot-scope="scope">{{ scope.row.withdrawFlag == "Y"?"可提现":"禁止提现" }}</template>
            </el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" align="center" width="140"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
        <el-dialog title="会员详情" :visible.sync="editDialogVisible" class="abow_dialog" @close="closeDialog" center>
            <el-form ref="editFormRef" :model="form" :rules="rules" label-width="180px" class="approveForm">
                <el-row>
                    <el-form-item label="会员地址">
                        <span>{{ form.address }}</span>
                    </el-form-item>
                </el-row> 
                <el-row>
                    <el-form-item label="备注">
                        <el-input v-model="form.nickName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="提现状态" prop="withdrawFlag">
                        <el-select v-model="form.withdrawFlag">
                            <el-option label="可提现" value="Y"></el-option>
                            <el-option label="禁止提现" value="N"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="社区真实等级">
                        <span>V{{ form.teamLevelAuto }}</span>
                    </el-form-item>
                    <el-form-item label="社区设置等级" prop="teamLevelSet">
                        <el-select v-model="form.teamLevelSet">
                            <el-option label="不设置" :value="0"></el-option>
                            <el-option label="V1" :value="1"></el-option>
                            <el-option label="V2" :value="2"></el-option>
                            <el-option label="V3" :value="3"></el-option>
                            <el-option label="V4" :value="4"></el-option>
                            <el-option label="V5" :value="5"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row> 
                <div style="color:red;margin-top:30px;text-align: center;">
                    <p>PS：手动设置社区等级后，会以设置的等级进行结算。</p>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitUpdate">提交</el-button>
                <el-button @click="closeDialog">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { memberServiceApi } from '@/api/api-sys';
import { aldServiceApi } from '@/api/api-ald';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
export default {
    data() {
        return {
            levelOptions:[],
            levelMap:{},
            rules: {
                // selfLevelSet: [{ required: true, message: ' ' }],
                // inviteLevelSet: [{ required: true, message: ' ' }],
                teamLevelSet: [{ required: true, message: ' ' }],
                withdrawFlag: [{ required: true, message: ' ' }],
            },
            params: {},
            total:0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData:[],
            statusOptions:[],
            statusMap:{},

            editDialogVisible: false,
            form: {},
            activeName:"",
            inviteList:[],
            orderList:[],
            mineList:[],
        };
    },
    created() {
        this.levelOptions = this.findDict("levelLabel");
        this.levelMap = this.listToMap(this.levelOptions,"code","name");
        this.handleSearch();
    },
    methods: {
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        handleSearch() {
            memberServiceApi.findPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        syncLeaderData(){
            this.showLoadingBox();
            aldServiceApi.syncLeaderData().then(res => {
                if (res.result) {
                    this.handleSearch()
                    this.$message.success("同步完成");
                } else {
                    if(res.msg){
                        this.$message.error(res.msg);
                    }else{
                        this.$message.error("同步失败");
                    }
                }
                this.hideLoadingBox();
            });
        },
        openEdit(data) {
            this.form = {};
            this.editDialogVisible = true;
            this.form = JSON.parse(JSON.stringify(data));
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
        },
        closeDialog() {
            this.editDialogVisible = false;
        },
        submitUpdate() {
            this.$refs.editFormRef.validate(valid => {
                if (!valid) {
                    return;
                }
                memberServiceApi.updateMember({
                    id:this.form.id,
                    nickName:this.form.nickName,
                    whiteFlag:this.form.whiteFlag,
                    withdrawFlag:this.form.withdrawFlag,
                    selfLevelSet:this.form.selfLevelSet,
                    inviteLevelSet:this.form.inviteLevelSet,
                    teamLevelSet:this.form.teamLevelSet
                }).then(res => {
                    if (res.result) {
                        this.$message.success('提交成功');
                        this.closeDialog();
                        this.handleSearch();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            });
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['UID', '会员地址', '昵称','注册时间','白名单','直推地址', 
            '自己总金额', '自己真实等级','自己设置等级', 
            '直推总人数',"直推总金额","直推真实等级","直推设置等级","直推总收益",
            '社区总人数','社区总金额',"社区真实等级","社区设置等级","社区总收益",
            "可提余额","已提总额","提现状态"];
            let columns = ['id', 'address', 'nickName','registerAt','whiteFlag','parentAddress',
            'selfAmount','selfLevelAuto','selfLevelSet',
            'inviteNum', 'inviteAmount','inviteLevelAuto','inviteLevelSet',"profitParent",
            'teamNum',"teamAmount","teamLevelAuto",'teamLevelSet',"profitLeader",
            "ctcBalance","withdrawTotal","withdrawFlag"];
            // let data = this.tableData.map(r => columns.map(c => {
            //     let val = r[c];
            //     if(c == 'levelAuto'){
            //         return "A"+val;
            //     }else if(c == 'levelByHand'){
            //         if(val>0){
            //             return "A"+val;
            //         }
            //         return "";
            //     }else if(c == 'daoLevelAuto'){
            //         if(val <= 0){
            //             return "不是节点";
            //         }
            //         return "N"+(val-1);
            //     }else if(c == 'daoLevelSet'){
            //         if(val > 0){
            //             return "N"+(val-1);
            //         }
            //         return "";
            //     }else{
            //         let val = r[c];
            //         if(typeof val === 'number'){
            //             return this.toDecimalVal(val,10);
            //         }
            //         return val;
            //     }   
            // }));
            let data = this.tableData.map(r => columns.map(c => {
                let val = r[c];
                return val;
            }));
            exportData2(header,data,"会员数据");
        }
    }
};
</script>
<style lang='less' scope>
span.flag{
    color:red;
}
</style>